export default __webpack_public_path__ + "static/media/half-face-mask.dc692657.svg";